"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

/*
 When adding a new ObjectType you need to update the CRMToContactsObjectTypes mapping
 https://git.hubteam.com/HubSpot/CRM/blob/master/crm_data/static/js/constants/CRMToContactsObjectTypes.js
*/
var _default = (0, _keyMirror.default)({
  COMPANY: null,
  CONTACT: null,
  DEAL: null,
  ENGAGEMENT: null,
  FEEDBACK_SUBMISSION: null,
  LINE_ITEM: null,
  PRODUCT: null,
  QUOTE: null,
  TASK: null,
  TICKET: null,
  VISIT: null
});

exports.default = _default;
module.exports = exports.default;